import { Injectable } from '@angular/core';
import { MatSnackBar, MatDialog, MatDialogRef } from '@angular/material';

import { SnackbarComponent } from './snackbar/snackbar.component';
import { DialogComponent } from './dialog/dialog.component';
import { SnackbarOptionsModel } from './models/snackbar-options.model';
import { DialogOptionsModel } from './models/dialog-options.model';

@Injectable()
export class UserFeedbackService {

    private _defaultSnackBarDuration = 4000;
    private _defaultSnackBarStatus = 'success';

    /**
     * Constructor
     *
     * @param _snackBar material snack bar service
     */
    constructor(
        private _dialog: MatDialog,
        private _snackBar: MatSnackBar) { }

    // SNACK BAR METHODS ---------------------------------------------------------

    openSnackbar(options: SnackbarOptionsModel): void {

        this._snackBar.openFromComponent(SnackbarComponent, {
            duration: options.duration || this._defaultSnackBarDuration,
            data: { message: options.message, status: options.status || this._defaultSnackBarStatus }
        });

    }

    // DIALOG BAR METHODS --------------------------------------------------------

    openDialog(dialogData: DialogOptionsModel): MatDialogRef<DialogComponent> {

        let dialogRef: MatDialogRef<DialogComponent>;

        if (!dialogData.title) {

            switch (dialogData.type) {

                case 'confirm':
                    dialogData.title = 'CONFIRMACIÓN';
                    break;
                default:
                    dialogData.title = 'INFORMACIÓN';

            }

        } else {

            dialogData.title = dialogData.title.toUpperCase();

        }

        dialogRef = this._dialog.open(DialogComponent, {
            disableClose: true,
            data: dialogData,
            maxWidth: '33vw'
        });

        return dialogRef;

    }

}



// WEBPACK FOOTER //
// ./src/app/modules/user-feedback/user-feedback.service.ts